import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals, UsersService } from '@ubie/core';

@Component({
  selector: 'acl-forgot-password-v2',
  standalone: false,
  templateUrl: './forgot-password-v2.component.html',
  styleUrl: './forgot-password-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordV2Component {
  private readonly userService = inject(UsersService);
  private readonly globals = inject(Globals);
  private readonly router = inject(Router);

  readonly form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  readonly isFormSubmitted = signal(false);

  readonly currentSlide = signal(0);

  submitEmail(): void {
    this.isFormSubmitted.set(true);

    if (this.form.valid) {
      this.currentSlide.set(1);
      this.resetPassword(this.form.value['email']);
    }
  }
  async gotoLogin(): Promise<void> {
    await this.router.navigate(['login']);
  }

  resetPassword(email: string): void {
    this.userService.resetPassword(email).subscribe({
      next: () => {
        // slide to success page
        this.currentSlide.set(2);
      },
      error: () => {
        // slide to failed page
        this.currentSlide.set(3);
      },
    });
  }
}
